import { Component } from '@angular/core';

@Component({
    selector: 'cr-avid-back-button-svg',
    templateUrl: './back-button-svg.component.html',
    styleUrls: ['./back-button-svg.component.scss'],
})
export class BackButtonSvgComponent {}
